import { IsNotEmpty, IsIn, IsOptional, IsUUID, IsInt } from 'class-validator';

import type {
  DeadlineReference,
  DeadlineUnit,
  DeadlineOutcome,
} from '@vk-hr-tek/ui/FlowTree';

export class Deadline {
  @IsIn([
    '-',
    'event_deadline',
    'node_active',
    'attribute',
    'created_date',
    'created_datetime',
  ])
  @IsNotEmpty()
  reference: DeadlineReference;

  @IsUUID()
  @IsOptional()
  attribute?: string;

  @IsIn(['workday', 'day', 'hour', 'minute'])
  @IsNotEmpty()
  unit: DeadlineUnit;

  @IsInt({ message: 'Вы ввели некорректное количество' })
  @IsNotEmpty({ message: 'Вы забыли ввести количество' })
  term: number;

  @IsIn(['true', 'false'])
  @IsNotEmpty()
  round: 'true' | 'false';

  @IsIn(['to_paper', 'skip', 'cancel'])
  @IsNotEmpty()
  outcome: DeadlineOutcome;
}
